import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth2patchPatchScreenTruthAppsAppBindingsRoleDataStateResponseSchema = jsonObject
export type tcpscreentruth2patchPatchScreenTruthAppsAppBindingsRoleDataStateResponse = z.infer<typeof tcpscreentruth2patchPatchScreenTruthAppsAppBindingsRoleDataStateResponseSchema>
